<script setup>

import { ref, watch, computed } from 'vue';
import IndexFilterType from './IndexFilterType.vue';
import scrolllock from 'scroll-lock';

const props = defineProps({
    articleFilters: {
        type: Object,
        default: () => []
    }
})

const selectedFilters = defineModel('selectedFilters');

const isFilterOpen = ref(window.innerWidth > 992);

const hasFilters = computed(() => {
    return Object.keys(props.articleFilters).length > 0;
});

window.addEventListener('resize', () => {
    if (window.innerWidth > 992) {
        isFilterOpen.value = true;
        scrolllock.enablePageScroll();
    } else {
        isFilterOpen.value = false;
    }
});

watch(isFilterOpen, (value) => {
    if (value) {
        scrolllock.disablePageScroll();
    } else {
        scrolllock.enablePageScroll();
    }
});

</script>

<template>
    <section class="section m-articles-filter" v-if="hasFilters">
        <button class="m-articles-filter__toggle" aria-expanded="false" @click="isFilterOpen = !isFilterOpen">
            <svg class="icon icon-filters">
                <use xlink:href="#icon-filters"></use>
            </svg>
            Filters
        </button>

        <div class="m-articles-filter__inner" v-if="isFilterOpen">
            <h3 class="m-articles-filter__heading">
                Filters
            </h3>

            <button class="m-articles-filter__close" @click="isFilterOpen = false">
                <span class="screen-reader-text">Filters sluiten</span>
                <svg class="icon icon-close">
                    <use xlink:href="#icon-close"></use>
                </svg>
            </button>

            <IndexFilterType v-for="(filterType, type) in articleFilters" :key="filterType.type"
                :filterType="filterType" v-model:selectedFilters="selectedFilters[type]" />

            <div class="m-articles-filter__buttons">
                <button class="m-articles-filter__button m-articles-filter__button--clear"
                    @click="Object.keys(selectedFilters).forEach(key => selectedFilters[key] = []); isFilterOpen = false;">
                    Alles wissen
                </button>

                <button class="m-articles-filter__button m-articles-filter__button--apply"
                    @click="isFilterOpen = false">
                    Toepassen
                </button>
            </div>
        </div>
    </section>
</template>